import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Menu from '@mui/material/Menu';
import MenuIcon from '@mui/icons-material/Menu';
import Container from '@mui/material/Container';
import Button from '@mui/material/Button';
import MenuItem from '@mui/material/MenuItem';
import './navbar.css'
import logo from './logomn2.png'

const pages = ['Home', 'About-Us', 'Contact-Us'];

function ResponsiveAppBar() {
  const [anchorElNav, setAnchorElNav] = React.useState(null);

  const handleOpenNavMenu = (event) => {
    setAnchorElNav(event.currentTarget);
  };
  

  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };

 

  return (
    <AppBar position="sticky" className='navbar'>
      <Container maxWidth="xl">
        <Toolbar disableGutters>

          <Typography
           className='menu'
            variant="h6"
            noWrap
            component="a"
            href="/"
            sx={{
              mr: 2,
              display: { xs: 'none', md: 'flex' },
              fontFamily: 'monospace',
              fontWeight: 700,
              letterSpacing: '.3rem',
              color: 'gold',
              textDecoration: 'none'
            }}
          >
            <img style={{height:'100px',
              width:'100px',objectFit:'contain'}} src={logo} alt=''></img>
          </Typography>

          <Box sx={{ flexGrow: 1, display: { xs: 'flex', md: 'none' } }}>
            <IconButton
              size="large"
              aria-label="account of current user"
              aria-controls="menu-appbar"
              aria-haspopup="true"
              onClick={handleOpenNavMenu}
              color="inherit"
            >
              <MenuIcon />
            </IconButton>
            <Menu
              id="menu-appbar"
              anchorEl={anchorElNav}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
              }}
              keepMounted
              transformOrigin={{
                vertical: 'top',
                horizontal: 'left',
              }}
              open={Boolean(anchorElNav)}
              onClose={handleCloseNavMenu}
              sx={{
                display: { xs: 'block', md: 'none' },
              }}
            >
              {pages.map((page) => (
                <MenuItem className='menu'  key={page} onClick={handleCloseNavMenu}>
                  <Typography textAlign="center" component="a" href={`/${page}`} style={{ textDecoration: 'none', color: 'inherit',fontWeight:'normal',fontStyle:'OpenSans',fontSize:'1rem' }}>
                    {page}
                  </Typography>
                </MenuItem>
              ))}
            </Menu>
          </Box>
         
          <Typography
           className='menu'
            variant="h5"
            noWrap
            component="a"
            href="/"
            sx={{
              mr: 2,
              display: { xs: 'flex', md: 'none' },
              flexGrow: 1,
              fontFamily: 'Cinzel Decorative',
              fontWeight: 600,
              letterSpacing: '.3rem',
              color: 'gold',
              textDecoration: 'none',
              objectFit:'contain'
            }}
          >
            <img style={{height:'100px',
              width:'100px'}} src={logo} alt=''></img>
        
          </Typography>
          <Box sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex' } }}>
            {pages.map((page) => (
              <Button 
              className='menu' 
                key={page}
                onClick={handleCloseNavMenu}
                sx={{ my: 2,color:'gold', display: 'block',fontWeight:'normal',fontStyle:'OpenSans',fontSize:'1rem'  }}
                component="a"
                href={`/${page}`}
              >
                {page}
              </Button>
            ))}
          </Box>

         
        </Toolbar>
      </Container>
    </AppBar>
  );
}

export default ResponsiveAppBar;
